import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  // routes: [
  //   { path: "/", component: () => import("./views/Utama/Index.vue") },
  //   { path: "/about", component: () => import("./views/About.vue") },
  //   //404 page
  //   { path: "*", component: () => import("./views/NotFound.vue") },
  // ],

  routes: [
    //================================Login layout & Others============================================

    {
      path: "/login",
      name: "login",
      component: () => import("./views/login.vue"),
    },
    {
      path: "/book",
      name: "book",
      component: () => import("./views/Books/index.vue"),
    },
    {
      //================================Auth layout============================================
      path: "",
      component: () => import("./MainLayout.vue"),
      children: [
        //   path: "/",
        //   name: "Dashboard",
        //   component: () => import("./views/Home.vue")
        // },
        {
          path: "/",
          redirect: "/guest",
        },

        // {
        //   path: "",
        //   name: "test",
        //   component: () => import("./views/test.vue"),
        // },
        { path: "/home", component: () => import("./views/Utama/Index.vue") },
        { path: "/about", component: () => import("./views/About.vue") },
        {
          path: "/flipbook",
          component: () => import("./views/Jkt/Flipbook.vue"),
        },
      ],
    },
    {
      //================================Guest layout============================================
      path: "",
      component: () => import("./GuestLayout.vue"),
      children: [
        {
          path: "/test",
          name: "test",
          component: () => import("./views/test.vue"),
        },

        { path: "/guest", component: () => import("./views/Utama/Index.vue") },

        //404 page
        { path: "*", component: () => import("./views/NotFound.vue") },
      ],
    },
  ],
});

router.afterEach(() => {
  // Use the router instance for afterEach
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;

// const routes = [
//     {
//       path: '/',
//       component: GuestLayout,
//       children: [
//         {
//           path: '',
//           name: 'home',
//           component: Home
//         },
//         {
//           path: 'login',
//           name: 'login',
//           component: Login
//         }
//       ]
//     },
//     {
//       path: '/app',
//       component: AuthLayout,
//       children: [
//         {
//           path: 'dashboard',
//           name: 'dashboard',
//           component: Dashboard
//         },
//         {
//           path: 'profile',
//           name: 'profile',
//           component: Profile
//         }
//       ],
//       meta: { requiresAuth: true }
//     }
//   ];

//   const router = new Router({
//     mode: 'history',
//     routes
//   });

//   // Navigation guard to check for authenticated access
//   router.beforeEach((to, from, next) => {
//     const loggedIn = !!localStorage.getItem('user'); // Example check

//     if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
//       next('/login');
//     } else {
//       next();
//     }
//   });

//   export default router;
